(() => {
  const body = document.body;
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let lastTrigger = null;

  function setOpen(target, open, trigger) {
    if (!target) return;
    target.classList.toggle('is-open', open);
    target.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('is-locked', open);
    if (trigger) {
      trigger.setAttribute('aria-expanded', String(open));
      lastTrigger = trigger;
    }
    if (open) {
      const first = target.querySelector(focusableSelector);
      if (first) first.focus({ preventScroll: true });
    } else if (lastTrigger) {
      lastTrigger.focus({ preventScroll: true });
    }
  }

  function closeHeaderMenus(exceptItem) {
    document.querySelectorAll('[data-header-menu-item].is-open').forEach((item) => {
      if (exceptItem && (item === exceptItem || item.contains(exceptItem))) return;
      item.classList.remove('is-open');
      const trigger = item.querySelector(':scope > [data-header-menu-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.querySelectorAll('[data-header-menu-item]').forEach((item) => {
    const trigger = item.querySelector(':scope > [data-header-menu-trigger]');
    if (!trigger) return;
    const setExpanded = (expanded) => {
      if (window.matchMedia('(min-width: 990px)').matches) trigger.setAttribute('aria-expanded', String(expanded));
    };
    item.addEventListener('mouseenter', () => setExpanded(true));
    item.addEventListener('mouseleave', () => {
      if (!item.classList.contains('is-open')) setExpanded(false);
    });
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget) && !item.classList.contains('is-open')) setExpanded(false);
    });
  });

  document.addEventListener('click', (event) => {
    const menuTrigger = event.target.closest('[data-header-menu-trigger]');
    if (menuTrigger && window.matchMedia('(min-width: 990px)').matches) {
      const item = menuTrigger.closest('[data-header-menu-item]');
      if (item && !item.classList.contains('is-open')) {
        event.preventDefault();
        closeHeaderMenus(item.parentElement.closest('[data-header-menu-item]'));
        item.classList.add('is-open');
        menuTrigger.setAttribute('aria-expanded', 'true');
        return;
      }
    }

    if (!event.target.closest('.site-header__nav')) closeHeaderMenus();

    const opener = event.target.closest('[data-overlay-open]');
    if (opener) {
      event.preventDefault();
      setOpen(document.getElementById(opener.dataset.overlayOpen), true, opener);
      return;
    }
    const closer = event.target.closest('[data-overlay-close]');
    if (closer) {
      event.preventDefault();
      setOpen(closer.closest('.drawer,.search-panel'), false);
      return;
    }
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) {
      const input = quantityButton.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      const direction = Number(quantityButton.dataset.quantityChange || 0);
      const min = Number(input.min || 0);
      input.value = Math.max(min, Number(input.value || 0) + direction);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openOverlay = document.querySelector('.drawer.is-open,.search-panel.is-open');
    if (openOverlay) {
      setOpen(openOverlay, false);
      return;
    }
    const openMenu = document.querySelector('[data-header-menu-item].is-open');
    if (openMenu) {
      const trigger = openMenu.querySelector(':scope > [data-header-menu-trigger]');
      closeHeaderMenus();
      trigger?.focus({ preventScroll: true });
    }
  });

  const announcement = document.querySelector('[data-announcement]');
  if (announcement && 'ResizeObserver' in window) {
    const observer = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--as-announcement-height', `${entry.contentRect.height}px`);
    });
    observer.observe(announcement);
  }

  const siteHeader = document.querySelector('.site-header');
  if (siteHeader && 'ResizeObserver' in window) {
    const headerObserver = new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--as-header-height', `${entry.contentRect.height}px`);
    });
    headerObserver.observe(siteHeader);
  }

  function initializePredictiveSearch(form) {
    if (!form || form.dataset.predictiveSearchInitialized === 'true') return;
    const input = form.querySelector('[data-predictive-search-input]');
    const panel = form.querySelector('[data-predictive-search-results]');
    if (!input || !panel) return;

    const minimumCharacters = Math.max(1, Number(form.dataset.minChars || 2));
    let debounceTimer = null;
    let requestController = null;
    let keyboardIndex = -1;
    let lastCompletedQuery = '';

    const setPanelOpen = (open) => {
      panel.hidden = !open;
      input.setAttribute('aria-expanded', String(open));
      if (!open) keyboardIndex = -1;
    };

    const renderStatus = (message) => {
      const status = document.createElement('p');
      status.className = 'predictive-search__status';
      status.setAttribute('role', 'status');
      status.textContent = message;
      panel.replaceChildren(status);
      setPanelOpen(true);
    };

    const productImage = (product) => {
      const source = product.featured_image || product.image;
      if (typeof source === 'string') return source;
      return source?.url || source?.src || '';
    };

    const renderProducts = (products, query) => {
      panel.replaceChildren();

      if (products.length) {
        const list = document.createElement('ul');
        list.className = 'predictive-search__list';
        list.setAttribute('role', 'none');

        products.forEach((product) => {
          const item = document.createElement('li');
          item.setAttribute('role', 'none');
          const link = document.createElement('a');
          const imageUrl = productImage(product);
          link.className = `predictive-search__link${imageUrl ? '' : ' predictive-search__link--no-image'}`;
          link.href = product.url;
          link.setAttribute('role', 'option');

          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'predictive-search__image';
            image.src = imageUrl;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 104;
            image.height = 104;
            link.append(image);
          }

          const copy = document.createElement('span');
          copy.className = 'predictive-search__copy';
          const title = document.createElement('strong');
          title.className = 'predictive-search__title';
          title.textContent = product.title;
          copy.append(title);

          const metadata = [product.vendor, product.product_type].filter(Boolean).join(' · ');
          if (metadata) {
            const meta = document.createElement('span');
            meta.className = 'predictive-search__meta';
            meta.textContent = metadata;
            copy.append(meta);
          }

          link.append(copy);
          item.append(link);
          list.append(item);
        });

        panel.append(list);
      } else {
        const status = document.createElement('p');
        status.className = 'predictive-search__status';
        status.textContent = `No products found for “${query}”.`;
        panel.append(status);
      }

      const allResults = document.createElement('a');
      const searchUrl = new URL(form.action, window.location.origin);
      searchUrl.searchParams.set('q', query);
      searchUrl.searchParams.set('type', 'product');
      searchUrl.searchParams.set('options[prefix]', 'last');
      allResults.className = 'predictive-search__all';
      allResults.href = searchUrl.toString();
      allResults.textContent = `View all results for “${query}”`;
      panel.append(allResults);
      setPanelOpen(true);
    };

    const fetchProducts = async (query) => {
      requestController?.abort();
      requestController = new AbortController();
      renderStatus('Finding matching products…');
      panel.setAttribute('aria-busy', 'true');

      const root = window.Shopify?.routes?.root || '/';
      const endpoint = new URL(`${root}search/suggest.json`, window.location.origin);
      endpoint.searchParams.set('q', query);
      endpoint.searchParams.set('resources[type]', 'product');
      endpoint.searchParams.set('resources[limit]', '6');
      endpoint.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
      endpoint.searchParams.set('resources[options][prefix]', 'last');

      try {
        const response = await fetch(endpoint, {
          headers: { Accept: 'application/json' },
          signal: requestController.signal
        });
        if (!response.ok) throw new Error(`Predictive search failed with ${response.status}`);
        const data = await response.json();
        if (input.value.trim() !== query) return;
        lastCompletedQuery = query;
        renderProducts(data.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (input.value.trim() === query) renderStatus('Suggestions are unavailable. Press Enter to search.');
      } finally {
        panel.removeAttribute('aria-busy');
      }
    };

    const queueSearch = () => {
      window.clearTimeout(debounceTimer);
      const query = input.value.trim();
      if (query.length < minimumCharacters) {
        requestController?.abort();
        lastCompletedQuery = '';
        setPanelOpen(false);
        panel.replaceChildren();
        return;
      }
      debounceTimer = window.setTimeout(() => fetchProducts(query), 180);
    };

    input.addEventListener('input', queueSearch);
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length >= minimumCharacters) {
        if (query === lastCompletedQuery && panel.childElementCount) setPanelOpen(true);
        else queueSearch();
      }
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setPanelOpen(false);
        return;
      }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || panel.hidden) return;
      const links = [...panel.querySelectorAll('a')];
      if (!links.length) return;
      event.preventDefault();
      keyboardIndex = event.key === 'ArrowDown'
        ? (keyboardIndex + 1) % links.length
        : (keyboardIndex - 1 + links.length) % links.length;
      links.forEach((link, index) => link.classList.toggle('is-keyboard-active', index === keyboardIndex));
      links[keyboardIndex].focus({ preventScroll: true });
    });

    form.addEventListener('focusout', (event) => {
      if (!form.contains(event.relatedTarget)) window.setTimeout(() => setPanelOpen(false), 80);
    });
    document.addEventListener('click', (event) => {
      if (!form.contains(event.target)) setPanelOpen(false);
    });

    form.dataset.predictiveSearchInitialized = 'true';
  }

  document.querySelectorAll('[data-predictive-search]').forEach(initializePredictiveSearch);

  function initializeSlideshow(slideshow) {
    if (!slideshow || slideshow.dataset.slideshowInitialized === 'true') return;
    const slides = [...slideshow.querySelectorAll('[data-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-slide-dot]')];
    if (slides.length < 2) return;

    const previous = slideshow.querySelector('[data-slide-previous]');
    const next = slideshow.querySelector('[data-slide-next]');
    const autoplay = slideshow.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Math.max(3000, Number(slideshow.dataset.interval || 5000));
    let current = 0;
    let timer = null;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const start = () => {
      stop();
      if (autoplay) timer = window.setInterval(() => show(current + 1), interval);
    };

    previous?.addEventListener('click', () => { show(current - 1); start(); });
    next?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideDot)); start(); }));
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', (event) => {
      if (!slideshow.contains(event.relatedTarget)) start();
    });
    slideshow.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    });
    let touchStartX = null;
    slideshow.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX ?? null;
      stop();
    }, { passive: true });
    slideshow.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const endX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = endX - touchStartX;
      if (Math.abs(distance) > 55) show(current + (distance < 0 ? 1 : -1));
      touchStartX = null;
      start();
    }, { passive: true });

    slideshow.dataset.slideshowInitialized = 'true';
    show(0);
    start();
  }

  document.querySelectorAll('[data-slideshow]').forEach(initializeSlideshow);

  const collectionGridStorageKey = 'ancient-smithy-os2.collection-grid-view';
  const collectionGridViews = ['large', 'medium', 'compact'];

  function readCollectionGridView() {
    try {
      const view = window.localStorage.getItem(collectionGridStorageKey);
      return collectionGridViews.includes(view) ? view : null;
    } catch (_) {
      return null;
    }
  }

  function writeCollectionGridView(view) {
    try {
      window.localStorage.setItem(collectionGridStorageKey, view);
    } catch (_) {
      // Storage can be unavailable in private browsing; the controls still work for this page view.
    }
  }

  function initializeCollectionGrid(section) {
    if (!section || section.dataset.gridSwitcherInitialized === 'true') return;
    const grid = section.querySelector('[data-product-grid]');
    if (!grid) return;

    const buttons = [...section.querySelectorAll('[data-grid-view-button]')];
    const defaultView = collectionGridViews.includes(section.dataset.defaultGridView)
      ? section.dataset.defaultGridView
      : 'medium';
    const storedView = buttons.length && !window.Shopify?.designMode ? readCollectionGridView() : null;
    let currentView = storedView || defaultView;

    const updateGridView = (view, persist = false) => {
      if (!collectionGridViews.includes(view)) return;
      currentView = view;
      grid.dataset.gridView = view;

      buttons.forEach((button) => {
        const isMobileFallback = view === 'compact'
          && button.dataset.gridViewButton === 'medium'
          && Boolean(button.closest('.as-collection__view-switcher--mobile'));
        const isActive = button.dataset.gridViewButton === view || isMobileFallback;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (persist && !window.Shopify?.designMode) writeCollectionGridView(view);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => updateGridView(button.dataset.gridViewButton, true));
    });

    section.dataset.gridSwitcherInitialized = 'true';
    updateGridView(currentView);
  }

  document.querySelectorAll('[data-collection-grid-section]').forEach(initializeCollectionGrid);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('[data-collection-grid-section]')
      ? event.target
      : event.target.querySelector?.('[data-collection-grid-section]');
    initializeCollectionGrid(section);
  });

  function initializeCollectionFacets(section) {
    if (!section || section.dataset.facetsInitialized === 'true') return;
    const sidebar = section.querySelector('[data-facets-sidebar]');
    const backdrop = section.querySelector('.as-collection__facets-backdrop');
    const openButton = section.querySelector('[data-facets-open]');
    const closeButtons = [...section.querySelectorAll('[data-facets-close]')];

    const setFacetsOpen = (open) => {
      if (!sidebar) return;
      sidebar.classList.toggle('is-open', open);
      backdrop?.classList.toggle('is-open', open);
      openButton?.setAttribute('aria-expanded', String(open));
      body.classList.toggle('is-locked', open);
      if (open) sidebar.querySelector('button,input,summary,a')?.focus({ preventScroll: true });
      else openButton?.focus({ preventScroll: true });
    };

    openButton?.addEventListener('click', () => setFacetsOpen(true));
    closeButtons.forEach((button) => button.addEventListener('click', () => setFacetsOpen(false)));
    section.querySelectorAll('[data-facet-input]').forEach((input) => {
      input.addEventListener('change', () => input.form?.requestSubmit());
    });
    section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && sidebar?.classList.contains('is-open')) setFacetsOpen(false);
    });
    section.dataset.facetsInitialized = 'true';
  }

  document.querySelectorAll('[data-collection-grid-section]').forEach(initializeCollectionFacets);

  function initializeProductForm(productArea) {
    if (!productArea || productArea.dataset.productFormInitialized === 'true') return;
    const data = productArea.querySelector('[data-product-json]');
    const nativeForm = productArea.querySelector('form');
    if (!data || !nativeForm) return;

    let product;
    try { product = JSON.parse(data.textContent); } catch (_) { return; }

    const root = productArea.closest('[data-product-root]');
    const idInput = nativeForm.querySelector('input[name="id"]');
    const submit = nativeForm.querySelector('[data-main-product-submit]');
    const price = root?.querySelector('[data-product-price]');
    const comparePrice = root?.querySelector('.price__compare');
    const inventory = root?.querySelector('[data-product-inventory]');
    const mobileBuy = root?.querySelector('[data-mobile-buy]');
    const mobileBuyButton = mobileBuy?.querySelector('[data-mobile-buy-button]');
    const mobilePrice = mobileBuy?.querySelector('[data-mobile-product-price]');
    const moneyFormat = root?.dataset.moneyFormat || '${{amount}}';

    const formatMoney = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
      const amount = (Number(cents || 0) / 100).toFixed(2);
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents || 0) / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
    };

    const readOptions = () => [...nativeForm.querySelectorAll('[data-option-group]')].map((group) => {
      const checked = group.querySelector('[data-option-input]:checked');
      const select = group.querySelector('[data-option-select]');
      return checked?.value ?? select?.value;
    });

    const updateControls = (variant) => {
      const available = Boolean(variant?.available);
      const availableLabel = submit?.dataset.availableLabel || 'Add to cart';
      const soldOutLabel = submit?.dataset.soldOutLabel || 'Sold out';
      const label = available ? availableLabel : soldOutLabel;

      if (idInput && variant) idInput.value = variant.id;
      if (submit) {
        submit.disabled = !available;
        const submitLabel = submit.querySelector('[data-submit-label]');
        if (submitLabel) submitLabel.textContent = label;
      }
      if (mobileBuyButton) {
        mobileBuyButton.disabled = !available;
        mobileBuyButton.textContent = label;
      }

      if (variant && price) price.textContent = formatMoney(variant.price);
      if (variant && mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
      if (variant && comparePrice) {
        const isSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        comparePrice.hidden = !isSale;
        if (isSale) comparePrice.textContent = formatMoney(variant.compare_at_price);
      }

      if (inventory) {
        inventory.classList.toggle('is-available', available);
        inventory.classList.toggle('is-unavailable', !available);
        const inventoryLabel = inventory.querySelector('[data-inventory-label]');
        if (inventoryLabel) inventoryLabel.textContent = available
          ? inventory.dataset.availableLabel
          : inventory.dataset.unavailableLabel;
      }
    };

    const update = () => {
      const options = readOptions();
      const variant = options.length
        ? product.variants.find((item) => item.options.every((option, index) => option === options[index]))
        : product.variants.find((item) => String(item.id) === String(idInput?.value)) || product.variants[0];

      updateControls(variant);
      if (!variant) return;

      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      const gallery = root?.querySelector('[data-product-gallery]');
      if (mediaId && gallery) gallery.dispatchEvent(new CustomEvent('product:media:show', { detail: { mediaId: String(mediaId) } }));

      if (!window.Shopify?.designMode && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    nativeForm.querySelectorAll('[data-option-select],[data-option-input]').forEach((control) => {
      control.addEventListener('change', update);
    });

    mobileBuyButton?.addEventListener('click', () => {
      if (!submit?.disabled) submit?.click();
    });

    if (mobileBuy && submit && root) {
      const renderMobileBuy = () => {
        const submitRect = submit.getBoundingClientRect();
        const productRect = root.getBoundingClientRect();
        const visible = window.matchMedia('(max-width: 749px)').matches
          && submitRect.bottom < 0
          && productRect.bottom > 0;
        mobileBuy.classList.toggle('is-visible', visible);
        mobileBuy.setAttribute('aria-hidden', String(!visible));
      };
      window.addEventListener('scroll', renderMobileBuy, { passive: true });
      window.addEventListener('resize', renderMobileBuy, { passive: true });
      window.requestAnimationFrame(renderMobileBuy);
    }

    productArea.dataset.productFormInitialized = 'true';
    update();
  }

  function initializeProductGallery(gallery) {
    if (!gallery || gallery.dataset.productGalleryInitialized === 'true') return;
    const panels = [...gallery.querySelectorAll('[data-media-panel]')];
    const thumbnails = [...gallery.querySelectorAll('[data-media-thumbnail]')];
    if (!panels.length) return;

    const previous = gallery.querySelector('[data-media-previous]');
    const next = gallery.querySelector('[data-media-next]');
    const counter = gallery.querySelector('[data-media-current]');
    const stage = gallery.querySelector('.as-product__media-stage');
    let currentIndex = 0;

    const showMedia = (mediaId, { scrollThumbnail = false } = {}) => {
      panels.forEach((panel) => {
        const active = String(panel.dataset.mediaPanel) === String(mediaId);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', String(!active));
        if (!active) panel.querySelectorAll('video').forEach((video) => video.pause());
        if (active) currentIndex = panels.indexOf(panel);
      });

      thumbnails.forEach((thumbnail) => {
        const active = String(thumbnail.dataset.mediaThumbnail) === String(mediaId);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
        if (active && scrollThumbnail) thumbnail.scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      });

      if (counter) counter.textContent = String(currentIndex + 1);
    };

    const showByIndex = (index) => {
      const target = panels[(index + panels.length) % panels.length];
      if (target) showMedia(target.dataset.mediaPanel, { scrollThumbnail: true });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showMedia(thumbnail.dataset.mediaThumbnail, { scrollThumbnail: true }));
    });

    previous?.addEventListener('click', () => showByIndex(currentIndex - 1));
    next?.addEventListener('click', () => showByIndex(currentIndex + 1));
    gallery.addEventListener('product:media:show', (event) => showMedia(event.detail?.mediaId, { scrollThumbnail: true }));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showByIndex(currentIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showByIndex(currentIndex + 1); }
    });

    if (stage) {
      let touchStartX = null;
      stage.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX ?? null; }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const endX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = endX - touchStartX;
        if (Math.abs(distance) > 55) showByIndex(currentIndex + (distance < 0 ? 1 : -1));
        touchStartX = null;
      }, { passive: true });
    }

    gallery.dataset.productGalleryInitialized = 'true';
    const initial = thumbnails.find((thumbnail) => thumbnail.getAttribute('aria-current') === 'true')?.dataset.mediaThumbnail
      || panels[0].dataset.mediaPanel;
    showMedia(initial);
  }

  function initializeProductAddons(scope = document) {
    const roots = scope.matches?.('[data-product-root]')
      ? [scope]
      : [...scope.querySelectorAll?.('[data-product-root]') || []];

    roots.forEach((root) => {
      const clearInitialSelections = () => {
        root.querySelectorAll('.spice-spa-addon-checkbox-input').forEach((input) => {
          if (input.dataset.themeDefaultCheckedCleared === 'true') return;
          input.dataset.themeDefaultCheckedCleared = 'true';
          if (!input.checked) return;
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };

      clearInitialSelections();
      if (root.dataset.productAddonsObserved === 'true') return;

      const observer = new MutationObserver(clearInitialSelections);
      observer.observe(root, { childList: true, subtree: true });
      root.dataset.productAddonsObserved = 'true';
    });
  }

  function initializeProductSections(scope = document) {
    const productForms = scope.matches?.('[data-product-form]')
      ? [scope]
      : [...scope.querySelectorAll?.('[data-product-form]') || []];
    const productGalleries = scope.matches?.('[data-product-gallery]')
      ? [scope]
      : [...scope.querySelectorAll?.('[data-product-gallery]') || []];
    productForms.forEach(initializeProductForm);
    productGalleries.forEach(initializeProductGallery);
    initializeProductAddons(scope);
  }

  initializeProductSections();
  document.addEventListener('shopify:section:load', (event) => {
    initializeProductSections(event.target);
    const predictiveForms = event.target.matches?.('[data-predictive-search]')
      ? [event.target]
      : [...event.target.querySelectorAll?.('[data-predictive-search]') || []];
    predictiveForms.forEach(initializePredictiveSearch);
    const slideshow = event.target.matches?.('[data-slideshow]')
      ? event.target
      : event.target.querySelector?.('[data-slideshow]');
    initializeSlideshow(slideshow);
    const collectionSection = event.target.matches?.('[data-collection-grid-section]')
      ? event.target
      : event.target.querySelector?.('[data-collection-grid-section]');
    initializeCollectionFacets(collectionSection);
  });
})();
